import site from './site.json';

/**
 * Public address of the site, used for canonical links, social previews and structured
 * data. Set VITE_SITE_URL at build time (or edit site.json) once you have a custom domain.
 */
export const SITE_URL: string = (import.meta.env.VITE_SITE_URL || site.url).replace(/\/+$/, '');

/** "/products/" -> "/products", "" -> "/". Query strings and hashes are dropped. */
export function normalizePath(pathname: string): string {
  const path = pathname.split(/[?#]/)[0].replace(/\/+$/, '');
  return path === '' ? '/' : path;
}

/** Turns "/og-default.jpg" or a full URL into an absolute URL on this site. */
export function absoluteUrl(pathOrUrl: string): string {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;
}

/** Cuts text to a search-result-sized snippet on a word boundary. */
export function clamp(text: string, max = 155): string {
  const clean = text.replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(' ')).replace(/[,;:.\-\s]+$/, '')}…`;
}
